
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/saesonslut-for-skisteder",
      function () {
        return require("private-next-pages/[region]/saesonslut-for-skisteder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/saesonslut-for-skisteder"])
      });
    }
  